<svg 
  class="icon-credit-card"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 20 20"
  [attr.fill]="color"
  xmlns="http://www.w3.org/2000/svg"
>
  <path 
    d="M18.5028 5.05979V14.9402C18.5028 15.465 18.318 15.9121 17.9484 16.2817C17.5788 16.6513 17.1317 16.8361 16.6069 16.8361H3.39315C2.86838 16.8361 2.42122 16.6513 2.05165 16.2817C1.68209 15.9121 1.49731 15.465 1.49731 14.9402V5.05979C1.49731 4.53503 1.68211 4.08786 2.05169 3.71829C2.42125 3.34873 2.8684 3.16394 3.39317 3.16394H16.6069C17.1317 3.16394 17.5788 3.34873 17.9484 3.71829C18.318 4.08786 18.5028 4.53503 18.5028 5.05979ZM3.39315 6.65173H16.6069V5.05979H3.39315V6.65173ZM3.39315 9.98507V14.9402H16.6069V9.98507H3.39315Z" 
    fill="currentColor"
  />
</svg>
